import customPage from './validation/custom-page'
import workflow from './components/workflow'
import team from './components/team'
import organization from './components/organization'
import plugins from './components/plugins'
import inputTemplateForm from './components/input-template-form'
import incidents from './components/incidents'
import insights from './components/insights'
import customTable from './components/custom-table'
import customDomains, { errors as customDomainErrors } from './components/custom-domains'
import analyticsReports from './components/analytics-reports'
import customTableValidation from './validation/custom-table'

export default {
    validation: {
        'custom-page': customPage,
        'custom-table': customTableValidation,
    },
    common: {
        delete: 'Delete',
        preview: 'Preview',
        create: 'Create',
        submit: 'Submit',
        confirm: 'Confirm',
        save: 'Save',
        'save-changes': 'Save changes',
        close: 'Close',
        cancel: 'Cancel',
        oops: 'Ooops...',
        'something-went-wrong': 'Ooops... something went wrong',
        'try-again': 'Try again',
        success: 'Success',
        error: 'Error: {error}',
        'generic-error': 'Error',
        id: 'ID',
        language: 'Language',
        'discard-changes': 'You have unsaved changes. Are you sure you want to leave?',
        'select-all': 'Select all',
        'deselect-all': 'Deselect all',
    },
    components: {
        workflow,
        team,
        plugins,
        incidents,
        'custom-table': customTable,
        'custom-domains': customDomains,
        'input-template-form': inputTemplateForm,
        insights,
        'analytics-reports': analyticsReports,
        organization,
    },
    errors: {
        teamMember: {
            alreadyExists: 'Team member with this email already exists',
        },
        ...customDomainErrors,
    },
}
